var filter = (function () {
  /* ====  Tools ==== */

  // Get url param

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ?
          true :
          sParameterName[1];
      }
    }
  };

  // Remove query param

  function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length > 0) {
        rtn = rtn + "?" + params_arr.join("&");
      }
    }
    return rtn;
  }
  // Function to update URL param if it exists, or add if it doesn't
  function updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf("#");

    var hash = i === -1 ? "" : uri.substr(i);

    uri = i === -1 ? uri : uri.substr(0, i);
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), "");
      if (uri.slice(-1) === "?") {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf("?") === -1) uri = uri.replace(/&/, "?");
    } else if (uri.match(re)) {
      uri = uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      uri = uri + separator + key + "=" + value;
    }
    // Remove Current subcategoryParam
    return uri + hash;
  }

  var program_categories = [];

  $(".program-item").each(function () {
    var program_category_slug_string = $(this).data("category-slug");
    var program_category_string = $(this).data("category");


    $.each(program_category_string.split(/\|/), function (i, val) {
      var program_object = {
        "name": val,
        "slug": val.toLowerCase().replace(" ", "-").replace("&", "-").replace("--", "-")
      };

      program_categories.push(program_object);
    });

  });

  console.log(program_categories);

  $.each(program_categories, function (key, value) {
    var option = "<option value=" + value.slug + ">" + value.name + "</option>";

    if ($(".jquery-filter-items option[value='" + value.slug + "']").length == 0) {
      $(".jquery-filter-items").append(option);
    }

  });

  $(".jquery-filter-items").append($(".jquery-filter-items option:gt(0)").sort(function (a, b) {
    return a.text == b.text ? 0 : a.text < b.text ? -1 : 1;
  }));

  $(".filter-items").on("change", function () {
    if ($(this).val() == "All") {
      window.location.href = removeParam("result", window.location.href);
    } else {
      window.location = updateUrlParameter(window.location.href, "result", $(this).val());
    }
  });   

  var resultParam = getUrlParameter("result");

  if (resultParam) {
    $(".filter-items").find("option[value='" + resultParam + "']").prop("selected", true);
  }

  $(".jquery-filter-items").on("change", function() {
    if($(this).val() == "All") {
      $(".program-item").show();
      $(".conference-program").removeClass("hidden").show();
      $(".no-results-box").hide();
    } else {
      $(".program-item").removeClass("visible").hide();
      $(".program-item." + $(this).val()).addClass("visible").show();
      $(".conference-program").each(function() {
        if ($(this).find(".program-item.visible").length == 0) {
          $(this).hide().addClass("hidden");
        } else {
          $(this).show().removeClass("hidden");
        }
      });
      if($(".conference-program:not(.hidden)").length == 0) {
        $(".no-results-box").show();
      } else {
        $(".no-results-box").hide();
      }
    }
  });


  

})();
